import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { NgxGlideComponent } from 'ngx-glide';
import { Observable } from 'rxjs';
import { BreakpointService } from '../../shared/services/breakpoint.service';
import { BannerSliderService } from './banner-slider.service';
import { BannerSlide } from './banner-slide.interface';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-banner-slider',
  templateUrl: './banner-slider.component.html',
  styleUrls: ['./banner-slider.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    AsyncPipe,
    NgFor,
    NgClass,
    NgxGlideComponent,
    RouterLink,
  ]
})
export class BannerSliderComponent {
  constructor(
    private bannerSlider: BannerSliderService,
    public breakPoint: BreakpointService,
  ) {}

  bannerSlides$: Observable<BannerSlide[]> = this.bannerSlider.banners$
}
